<div class="bmc-blue-prism-configuration">
    <div class="bmc-blue-prism-configuration__title bz-flex bz-flex--spaced">
        <h4 class="bz-font-weight--semibold">{{ 'RPA_BOTS.RPA_CONFIGURATION' | translate }}</h4>
    </div>
    <h5 class="bz-space--stack-m">{{ 'BLUE_PRISM.CONFIGURATION_DESCRIPTION' | translate }}</h5>
    <form #botConfigForm="ngForm">
        <div class="bz-flex bz-space--stack-m">
            <bzg-input name="name" class="bmc-blue-prism-configuration__input  bz-space--inline-m" [required]="true" [(ngModel)]="botDetailData.displayName">
                {{ 'BLUE_PRISM.CONNECTION_NAME' | translate }}
                <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
            </bzg-input>
            <bzg-input name="url" class="bmc-blue-prism-configuration__input" [required]="true" [(ngModel)]="botDetailData.baseUrl" [pattern]="URL_REGEXP">
                {{ 'BLUE_PRISM.BASE_URL' | translate }}
                <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
                <bzg-pattern-error>{{'GLOBAL.INVALID_URL' | translate}}</bzg-pattern-error>
            </bzg-input>
        </div>
        <h5 class="bz-space--stack-m">{{ 'BLUE_PRISM.CREDENTIALS_DESCRIPTION' | translate }}</h5>
        <div class="bz-flex bz-space--stack-m">
            <bzg-password name="password" class="bmc-blue-prism-configuration__input bz-space--inline-m" [required]="true" [(ngModel)]="botDetailData.password">
                {{ 'GLOBAL.PASSWORD' | translate }}
                <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
            </bzg-password>
            <bzg-input name="email" class="bmc-blue-prism-configuration__input" [required]="true" [(ngModel)]="botDetailData.userName">
                {{ 'RPA_BOTS.USERNAME_EMAIL' | translate }}
                <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
            </bzg-input>
        </div>
    </form>
    <div class="bz-flex bz-flex--end bz-space--stack-l">
        <bzg-button-secondary class="bz-space--inline-m" (click)="onClearAll()">{{ 'BLUE_PRISM.CLEAR_ALL' | translate }}</bzg-button-secondary>
        <bzg-button-primary (click)="onTestConnection()">{{ 'BLUE_PRISM.TEST_BASE_URL' | translate }}</bzg-button-primary>
    </div>
</div>
<bot-processes [title]="'BLUE_PRISM.PROCESSES'" [botProcesses]="botDetailData.processes"></bot-processes>
<div class="bmc-blue-prism-configuration__buttons">
    <bzg-button-primary [disabled]="!isValid()" (click)="onSave()">{{ 'GLOBAL.SAVE' | translate }}</bzg-button-primary>
</div>